const charToByte = {
  'A': 0x00,
  'B': 0x01,
  'C': 0x02,
  'D': 0x03,
  'E': 0x04,
  'F': 0x05,
  'G': 0x06,
  'H': 0x07,
  'I': 0x08,
  'J': 0x09,
  'K': 0x0a,
  'L': 0x0b,
  'M': 0x0c,
  'N': 0x0d,
  'O': 0x0e,
  'P': 0x0f,
  'Q': 0x10,
  'R': 0x11,
  'S': 0x12,
  'T': 0x13,
  'U': 0x14,
  'V': 0x15,
  'W': 0x16,
  'X': 0x17,
  'Y': 0x18,
  'Z': 0x19,
  'a': 0x1a,
  'b': 0x1b,
  'c': 0x1c,
  'd': 0x1d,
  'e': 0x1e,
  'f': 0x1f,
  'g': 0x20,
  'h': 0x21,
  'i': 0x22,
  'j': 0x23,
  'k': 0x24,
  'l': 0x25,
  'm': 0x26,
  'n': 0x27,
  'o': 0x28,
  'p': 0x29,
  'q': 0x2a,
  'r': 0x2b,
  's': 0x2c,
  't': 0x2d,
  'u': 0x2e,
  'v': 0x2f,
  'w': 0x30,
  'x': 0x31,
  'y': 0x32,
  'z': 0x33,
  0: 0x34,
  1: 0x35,
  2: 0x36,
  3: 0x37,
  4: 0x38,
  5: 0x39,
  6: 0x3a,
  7: 0x3b,
  8: 0x3c,
  9: 0x3d,
  '-': 0x3e,
  '_': 0x3f,
};

const isToSAccepted = (bit?: number, mask?: string) => {
  if (bit === undefined) return true;

  if (!mask) return false;

  const blocks = Array.from(mask);
  const block = Math.floor(bit / 6);
  let ret = false;

  if (block < blocks.length) {
    const charByte = blocks[block];
    const byte = charToByte[charByte as keyof typeof charToByte];

    ret = Boolean((byte >> (bit % 6)) & 0x1);
  }

  return ret;
};

export { isToSAccepted };
